<div *ngIf="showLocalDevAlert" class="alert-local-dev">
  LOCAL DEV
</div>
<div *ngIf="localStorageNonProdEndpoint" class="alert-local-dev">
  NON-PROD ENDPOINT
</div>
